import { render, staticRenderFns } from "./NewsList.vue?vue&type=template&id=9d5e847e&"
import script from "./NewsList.vue?vue&type=script&lang=ts&"
export * from "./NewsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/llv-unitadmin/llv-unitadmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d5e847e')) {
      api.createRecord('9d5e847e', component.options)
    } else {
      api.reload('9d5e847e', component.options)
    }
    module.hot.accept("./NewsList.vue?vue&type=template&id=9d5e847e&", function () {
      api.rerender('9d5e847e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NewsList.vue"
export default component.exports